var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.commentComponent,_vm._b({tag:"component",scopedSlots:_vm._u([{key:"empty",fn:function(){return [_vm._t("empty")]},proxy:true}],null,true)},'component',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }